import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './../styles.css';

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const getPageName = () => {
    switch (location.pathname) {
      case '/applications':
        return 'Applications';
      case '/contacts':
        return 'Contacts';
      case '/insights':
        return 'Insights';
      default:
        return '';
    }
  };

  const handleNavigationClick = (e, path) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate(path);
    }, 2000);
  };

  return (
    <nav className="navbar">
      <div className="menu-container">
        <div className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <div className="close-icon">&times;</div> : <div className="hamburger-menu">&#9776;</div>}
          {menuOpen ? null : <span>{getPageName()}</span>}
        </div>
      </div>
      <h1 className="navbar-title">Job Tracker</h1>
      {menuOpen && (
        <div className="menu">
          <ul>
            <li>
              <Link to="/applications" onClick={(e) => handleNavigationClick(e, '/applications')}>Applications</Link>
            </li>
            <li>
              <Link to="/contacts" onClick={(e) => handleNavigationClick(e, '/contacts')}>Contacts</Link>
            </li>
            <li>
              <Link to="/insights" onClick={(e) => handleNavigationClick(e, '/insights')}>Insights</Link>
            </li>
            <li>
              <Link to="/" onClick={(e) => handleNavigationClick(e, '/')}>Log Out</Link>
            </li>
          </ul>
        </div>
      )}
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
    </nav>
  );
}

export default NavBar;
